<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :data="tableData"
      :columns="columns"
      :showSearchIcon="true"
      :lazy="true"
      :load="handleLoad"
      :loading="loading"
      :total="total"
      rowKey="libraryId"
      @onSearch="handleSearch"
    >
      <template #funBtn>
        <el-row :gutter="8">
          <el-col :span="1.5">
            <el-button
              type="primary"
              icon="Plus"
              @click="handleAdd"
              v-hasPermi="['system::dict::parentAdd']"
              >新增</el-button
            >
          </el-col>
        </el-row>
      </template>
    </Table>
    <AddUpdate
      :data="addUpdateData"
      :title="addUpdateTitle"
      v-model="addUpdateOpen"
      @success="handleSuccess"
    ></AddUpdate>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import AddUpdate from "./addUpdate";
import {
  findLibrary,
  findChildLibraryByParentId,
  deleteLibrary,
} from "@/api/system/dict";
import { getCustomTableCols } from "@/tableColumn";
import { ref } from "vue";
import { isNull, copyByOtherObj } from "@/utils/fangerUtils";
import { alertBox, confirmBoxFun, succesMsg } from "@/utils/msgBox";
import useCacheStore from "@/store/modules/cache";

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "dict",
});

const cacheStore = useCacheStore();
const tableRef = ref(null);

const tableData = ref([]);
const total = ref(0);
const loading = ref(false);

const addUpdateData = ref({});
const addUpdateOpen = ref(false);
const addUpdateTitle = ref("新增");
let curUpdateData = {};

// 表格数据搜索
const handleSearch = (data) => {
  loading.value = true;
  findLibrary(data)
    .then((res) => {
      const resData = [];
      res.data.forEach((item) => {
        resData.push({
          ...item,
          hasChildren: true,
        });
      });
      tableData.value = resData;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};
// 子集数据懒加载
const handleLoad = (row, treeNode, resolve) => {
  findChildLibraryByParentId(row.libraryId).then((resData) => {
    const childData = [];
    resData.data.forEach((element) => {
      childData.push({
        hasChildren: true,
        ...element,
      });
    });
    resolve(childData);
  });
};

// 新增
const handleAdd = (event, row) => {
  addUpdateTitle.value = "新增";
  const addData = {};
  if (row) {
    curUpdateData = row;
    addData.libraryParentId = row.libraryId;
  } else {
    addData.libraryParentId = "0";
  }
  addUpdateData.value = addData;

  addUpdateOpen.value = true;
};

// 修改
const handleUpdate = (event, row) => {
  addUpdateTitle.value = "修改";
  addUpdateData.value = row;
  curUpdateData = row;
  addUpdateOpen.value = true;
};

// 刷新字典的子集
const handleRefresh = (data) => {
  tableRef.value.reLazyLoad(data);
};

// 删除字典
const handleDelete = async (event, row) => {
  const childLibraryData = await findChildLibraryByParentId(row.libraryId);
  if (childLibraryData.data.length > 0) {
    alertBox("当前字典存在子项，请先删除子项再进行删除", "确定", "error ");
    handleRefresh({ libraryId: row.libraryId });
  } else {
    confirmBoxFun(() => {
      deleteLibrary(row.libraryId).then((res) => {
        if (res.status === 1) {
          succesMsg("删除成功");
          if (row.libraryParentId === "0") {
            // 删除父节点
            refreshTable.value = !refreshTable.value;
          } else {
            // 删除子节点
            handleRefresh({ libraryId: row.libraryParentId });
            // tableRef.value.removeRowByEvent(event);
          }
        }
      });
    }, "是否确定删除");
  }
};
// 修改成功回调
const handleSuccess = (data) => {
  if (isNull(data.libraryId)) {
    // 新增
    if (data.libraryParentId === "0") {
      // 新增父级节点
      tableRef.value.onSearch();
    } else {
      // 新增自己节点
      handleRefresh(curUpdateData);
    }
  } else {
    copyByOtherObj(curUpdateData, data);
  }
  cacheStore.getDict();
};

const columns = getCustomTableCols([
  "libraryName",
  "libraryCode",
  "libraryDesc",
  "libraryCreatetime",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "新增",
        controlType: "primary",
        controlText: true,
        controlPermission: ["system::dict::childAdd"],
        controlFun: handleAdd,
      },
      {
        control: "button",
        controlName: "修改",
        controlType: "success",
        controlText: true,
        controlPermission: ["system::dict::update"],
        controlFun: handleUpdate,
      },
      {
        control: "button",
        controlName: "删除",
        controlType: "danger",
        controlText: true,
        controlPermission: ["system::dict::delete"],
        controlFun: handleDelete,
      },
    ],
  },
]);
</script>

<style lang="scss" scoped></style>
